import * as yup from 'yup';

export const passwordValidationSchema = yup.object({
  password: yup.string().required('Please enter your password to log in'),
});
